// Buttons Texts
// export const ENROLL_BTN = "Enroll Now";
// export const DEMO_BTN = "Apply For Demo";
// export const LEARN = "Laern More";
// export const CHECK = "Check It Out";
// export const FREE_DEMO = "Get Free Demo";
// export const JOIN = "Join Now";
// export const CONTACT = "Contact Us";
// export const SUBMIT = "Submit";
// export const CLOSE = "Close";
// export const NEXT = "Next";
// export const START_TODAY = "Start Today";
// export const CONTACT_NOW = "Contact Us Now";
// export const COMPLETE_BTN = "Complete";
// export const GET_DIRECTIONS = "Get Directions";

// import Banking from "../components/Courses/banking and finance";
import Cards from "../reusable/Cards";
import { IMAGES } from "./images";
import { NavItem_Course } from "./navBarConfig";

// home
export const ASIDE_HOME_HERO = {
  heading: "Unlock Your Future in Tech.",
  title: "Transform Your Career with In-Demand IT Courses",
  content:
    "Join thousands of learners and gain the skills in Data Science, AI & ML, Full Stack Development, and Digital Marketing that employers are looking for.",
  image: IMAGES.HOME_HERO,
  btnText_1: "Join Now",
  btnText_2: "Contact Us",
};

export const BATCHES_TITLE = "Upcoming Batches";

export const HOME_CARDS = [
  {
    heading: "Java Full stack web development",
    text_1: "Starts on 01 Nov 2024",
    text_2: "Lectured by Emily ",
    text_3: "Duration: 6 Months.",
    text_4: "Time: 10 am to 7 pm",
    image: IMAGES.CARD_IMG,
    btnText: "Enroll Now",
    icon_1: IMAGES.HOME_ICON_1,
    icon_2: IMAGES.HOME_ICON_2,
    icon_3: IMAGES.HOME_ICON_3,
    icon_4: IMAGES.HOME_ICON_4,
  },
  {
    heading: "Java Full stack web development",
    text_1: "Starts on 01 Nov 2024",
    text_2: "Lectured by Emily ",
    text_3: "Duration: 6 Months.",
    text_4: "Time: 10 am to 7 pm",
    image: IMAGES.CARD_IMG,
    btnText: "Enroll Now",
    icon_1: IMAGES.HOME_ICON_1,
    icon_2: IMAGES.HOME_ICON_2,
    icon_3: IMAGES.HOME_ICON_3,
    icon_4: IMAGES.HOME_ICON_4,
  },
  {
    heading: "Java Full stack web development",
    text_1: "Starts on 01 Nov 2024",
    text_2: "Lectured by Emily ",
    text_3: "Duration: 6 Months.",
    text_4: "Time: 10 am to 7 pm",
    image: IMAGES.CARD_IMG,
    btnText: "Enroll Now",
    icon_1: IMAGES.HOME_ICON_1,
    icon_2: IMAGES.HOME_ICON_2,
    icon_3: IMAGES.HOME_ICON_3,
    icon_4: IMAGES.HOME_ICON_4,
  },
];

export const HOME_DEMO_CARDS = [
  {
    image: IMAGES.HOME_DEMO_1,
    title: "Digital Marketing Live Demo",
    content:
      "Join Free Class of Digital Marketing Program. Interactive Session of 2 Hours from DM Expert.",
    btntext: "Get Free Demo",
  },
  {
    image: IMAGES.HOME_DEMO_2,
    title: "Digital Marketing Live Demo",
    content:
      "Join Free Class of Digital Marketing Program. Interactive Session of 2 Hours from DM Expert.",
    btntext: "Get Free Demo",
  },
  {
    image: IMAGES.HOME_DEMO_3,
    title: "Data Science Live Demo",
    content:
      "Join Free Class of Digital Marketing Program. Interactive Session of 2 Hours from DM Expert.",
    btntext: "Get Free Demo",
  },
];

export const HOME_BUSINESSES = {
  heading: "",
  title: `Empower Your Workforce with Industry-Leading Learning Programs`,
  content:
    "Upskill your employees with industry-leading training programs designed to drive business growth and innovation. Customized learning paths, expert-led courses, and globally recognized certifications—tailored for your organization’s success.",
  image: IMAGES.HOME_BUSINESS_HERO,
  btnText_1: "Join Now",
  btnText_2: "",
};

export const BUSSINESS_CARDS = [
  {
    heading: "28%",
    title: "Reduction in Training Costs",
    content: `Optimize learning investments with cost-effective training solutions that deliver high-impact results.`,
  },
  {
    heading: "40%",
    title: "Higher Retention Rates",
    content: `Engaged and well-trained employees are more likely to stay, reducing turnover and strengthening your workforce.`,
  },
  {
    heading: "32%",
    title: " More Employee Productivity",
    content:
      "Upskilled teams perform better, adapt faster, and contribute more effectively to business growth.",
  },
];


export const HOME_BUSSINENSS_DEMAND_SKILLS = {
  title: "Transform Your Teams with In-Demand Skills",
  content:"Empower your workforce with the right knowledge to drive business success. Our training solutions help organizations stay competitive by providing industry-relevant skills, world-class content, hands-on learning, and measurable insights",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: " In-Demand Skills",
      content: "Train teams in top digital economy skills to stay competitive.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: " World-Class Content",
      content: "Access 350+ premium courses from leading universities and experts.",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "Master skills via real-world projects, exercises, and case studies.",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Insights",
      content:
        "Track progress, measure impact, and align training with business goals.",
    },
  ],
};

export const HOME_BUSSINESS_ASIDE={
  title :"Ready to Future-Proof Your Workforce?",
  content :`Join thousands of organizations transforming their teams with our corporate training solutions.
Flexible Plans: Choose from scalable options to fit your budget.
Dedicated Support: Get expert guidance every step of the way.`,
  image : IMAGES.HOME_BUSSINESS_ASIDE,
  btnText_1:"Join Now",
  btnText_2:"",
}

  export const HOME_UNIVERSITIES={
    heading:"",
    title:`Empower Your Future with World-Class Learning`,
    content:"Equip your teams with in-demand skills through curated courses, certifications, and hands-on projects from top universities and industry leaders.",
    image:IMAGES.HOME_UNIVERSITY_HERO,
    btnText_1:"Join Now",
    btnText_2:"",
  }

  export const UNIVERSITIES_CARDS = [
    {
      heading: "75%",
      title: "Higher Enrollment",
      content: `Students prefer programs that offer industry-recognized micro-credentials to boost their career prospects.`,
    },
    {
      heading: "83%",
      title: "Stronger Job Applications",
      content: `Employers value Professional Certificates as they show practical, job-ready skills.`,
    },
    {
      heading: "92%",
      title: "Better Career Prospects",
      content:
        " Professional Certificates help students stand out and improve their chances of landing a job.",
    },
  ];
  
  export const HOME_UNIVERSITIES_LEFT_ASIDE={
    heading:"Career Advancement Program",
    title :"Help students gain job-ready skills through expert-led, hands-on training.",
    content :`With our Career Advancement Program, students can:
Obtain industry-recognized certifications for better career opportunities.
Develop essential skills that align with employer expectations.
Build a portfolio showcasing real-world projects.
Explore diverse career paths across multiple industries.
Our platform helps students gain the expertise and credentials needed to thrive in today’s job market.`,
    image : IMAGES.HOME_UNIVERSITY_LEFT_ASIDE,
    btnText_1:"Join Now",
    btnText_2:"",
  }

  export const HOME_UNIVERSITIES_RIGHT_ASIDE={
    heading:"Professional Certifications",
    title :"Discover why students and employers prioritize industry-recognized certifications.",
    content :`A global survey highlights that most students and employers see Professional Certificates as essential for career success. These certifications validate job-ready skills, increasing employability and credibility in competitive industries.

Integrate these certifications into your learning journey to enhance skills, improve career prospects, and meet industry demands. Our platform offers expert-designed courses that help students gain the qualifications they need for real-world success.
4o`,
    image : IMAGES.HOME_UNIVERSITY_RIGHT_ASIDE,
    btnText_1:"Join Now",
    btnText_2:"",
  }

  export const HOME_UNIVERSITIES_ALIGNED_TRAINING = {
    title: "Enhance Learning with Industry-Aligned Training",
    content:"Empower students and educators with job-focused courses and hands-on learning experiences.",
    Cards: [
      {
        icon: IMAGES.BANKING_ICON_5,
        heading: "Expert-Led Content",
        content: " Access a diverse range of courses from top universities and industry leaders.",
      },
      {
        icon: IMAGES.BANKING_ICON_4,
        heading: "Hands-On Projects",
        content: "Help students develop real-world skills through guided, practical projects.",
      },
      {
        icon: IMAGES.BANKING_ICON_1,
        heading: "Seamless Integration",
        content: "Connect our platform to your learning management system for a streamlined experience.",
      },

    ],
  };

  export const HOME_UNIVERSITIES_ASIDE={
    title :"Ready to Future-Proof Your Workforce?",
    content :`Join thousands of organizations transforming their teams with our corporate training solutions.
Flexible Plans: Choose from scalable options to fit your budget.
Dedicated Support: Get expert guidance every step of the way.`,
    image : IMAGES.HOME_BUSSINESS_ASIDE,
    btnText_1:"Join Now",
    btnText_2:"",
  }

// traning
export const TRAINING_HERO={
  title :"Trainings",
  content :`Whether you're looking for a quick skill boost or a comprehensive learning experience, our short-term 3 months and long-term 6 months trainings are designed to equip you with the in-demand skills that top employers are seeking. Enroll today and take the next step towards a successful IT career!`,
  image : IMAGES.TRAINING_HERO,
  btnText_1:"Start Today!",
  btnText_2:"Contact Us",
}

export const TRAINING_CARDS_1=[
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
  ]

export const TRAINING_CARDS_2=[
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
    {
      heading:"Java Full stack web development",
      text_1:"Starts on 01 Nov 2024" ,
      text_2:"Lectured by Emily ",
      text_3:"Duration: 6 Months.",
      text_4:"Time: 10 am to 7 pm",
      image:IMAGES.CARD_IMG,
      btnText:"Enroll Now",
      icon_1:IMAGES.HOME_ICON_1,
      icon_2:IMAGES.HOME_ICON_2,
      icon_3:IMAGES.HOME_ICON_3,
      icon_4:IMAGES.HOME_ICON_4,
    },
  ]

  export const TRAINING_BOTTOM_CONTENT={
    title:`Have Questions or 
Need More Information?`,
    content:`Our team is here to help! Whether you're unsure about which course to choose or need assistance with enrollment, feel free to reach out. We're just a click away!`,
    btnText:"Contact Us Now"
  }

  // about

export const ABOUT_HERO={
  heading:"About",
  title:`SRIM Edutech - 
Our Gateway to a Career in IT`,
  content:"Welcome to [Institute Name], a premier IT training institute dedicated to empowering individuals with the skills and knowledge needed to excel in today’s tech-driven world. With a focus on practical learning and hands-on experience, we offer both online and offline training options tailored to meet diverse learning needs and schedules.",
  image:IMAGES.ABOUT_HERO,
  btnText_1:"Contact Now",
  btnText_2:"Schedule Free Demo",
}

export const ABOUT_ASIDE={
  heading:"",
  title:"Our Programs",
  content:"We offer structured courses designed to fit various career goals and time commitments. Our 3-month short-term programs focus on specific skills and technologies, providing a solid foundation in a short time. For those looking to gain in-depth knowledge, our 6-month long-term programs dive deeper, covering advanced topics with comprehensive training that prepares students for real-world challenges.",
  image:IMAGES.ABOUT_ASIDE,
  btnText_1:"",
  btnText_2:""
}

export const WHY_CHOOSE_US ="Why Choose Us?"

export const ABOUT_CARDS=[
{
  image:IMAGES.ABOUT_ICON,
  title:"Flexible Learning",
  content:"Choose between online sessions or in-person classes at our state-of-the-art facility.",
  btnText:"Check it out",
  arrowIcon:IMAGES.ABOUT_ARROW_ICON
},
{
  image:IMAGES.ABOUT_ICON,
  title:"Expert Instructors",
  content:"Learn from industry professionals with years of experience who are dedicated to your success.",
  btnText:"Check it out",
  arrowIcon:IMAGES.ABOUT_ARROW_ICON
},
{
  image:IMAGES.ABOUT_ICON,
  title:`Hands-On Experience`,
  content:"Engage in practical projects and real-world scenarios that reinforce your learning.",
  btnText:"Check it out",
  arrowIcon:IMAGES.ABOUT_ARROW_ICON
},
{
  image:IMAGES.ABOUT_ICON,
  title:"Certification",
  content:"Earn recognized certifications that enhance your resume and job prospects.",
  btnText:"Check it out",
  arrowIcon:IMAGES.ABOUT_ARROW_ICON
}
]

export const ABOUT_MISSION={
  title:"Our Mission",
  content:`Our mission is to bridge the gap between theoretical knowledge and real-world application. We aim to equip our students with the technical expertise, confidence, and adaptability needed to succeed in the fast-evolving IT industry.`,
  btnText:""
}

export const ABOUT_BOTTOM_CONTENT={
  title:"No prior coding experience required",
  content:`Our team is here to help! Whether you're unsure about which course to choose or need assistance with enrollment, feel free to reach out.We’ll teach you everything you need to know!`,
  btnText:"Enroll Now"
}

// courses
// Banking and finance
//  page:1
  export const BANKING_HERO_PAGE_1={
    title:"Enhance Your Career",
    heading:"Relationship Management: Build Strong & Lasting Connections",
    content:"Become a skilled relationship manager with our hands-on, comprehensive course designed to help you develop strategic communication, negotiation, and client management skills. Whether you’re new to the field or looking to refine your expertise, this course will guide you in fostering long-term professional relationships that drive success in business and customer engagement.",
    btnText_1:"Enroll Now",
    btnText_2:"Schedule Free Demo",
    image:IMAGES.BANKING_HERO_1,
 }
  export const BANKING_COURSE_PAGE_1={
    image:IMAGES.BANKING_COURSE_1,
    title:"Why Choose Our Course?",
    Cards:[
      {
        icon:IMAGES.BANKING_ICON_1,
        heading:"Learn by Doing",
        content:"Our project-based curriculum ensures you gain real-world experience in relationship-building and client management."
      },
      {
        icon:IMAGES.BANKING_ICON_2,
        heading:"Industry-Recognized Certificate",
        content:"Receive a certificate that demonstrates your expertise in relationship management to potential employers.",

      },
      {
        icon:IMAGES.BANKING_ICON_3,
        heading:"Flexible Learning",
        content:"Study at your own pace with lifetime access to course materials.",

      },
       {
        icon:IMAGES.BANKING_ICON_4,
        heading:"Student Support",
        content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
      },
    ]

  }
   

  export const BANKING_DETAILS_PAGE_1={
  
    title:"Course Details",
    content:"",
    Cards:[
      {
        icon:IMAGES.BANKING_ICON_5,
        heading:"Duration",
        content:"8-12 weeks (self-paced or instructor-led options available)"
      },
      {
        icon:IMAGES.BANKING_ICON_4,
        heading:"Mode of Delivery",
        content:"Online, in-person, and hybrid options",

      },
      {
        icon:IMAGES.BANKING_ICON_1,
        heading:"Hands-on Learning",
        content:"80% practical assignments, case studies, and live interaction sessions",

      },
       {
        icon:IMAGES.BANKING_ICON_6,
        heading:"Access to Resources",
        content:"Study material, CRM tool tutorials, and 24/7 access to course forums",
      },
      {
        icon:IMAGES.BANKING_ICON_7,
        heading:"Expert Instructors",
        content:"Learn from industry experts with extensive experience in customer relationship management and business strategy.",
      },
    ]

  }

  export const BANKING_BOTTOM_CONTENT={
    title:"No prior experience required",
    content:`Our team is here to help! Whether you're unsure about which course to choose or need assistance with enrollment, feel free to reach out.We’ll teach you everything you need to know!`,
    btnText:"Enroll Now"
  }


  // page:2

  export const BANKING_HERO_PAGE_2={
    title:"Enhance Your Career",
    heading:"Relationship Management: Build Strong Connections for a Successful Future",
    content:"Become a skilled relationship manager with our hands-on, comprehensive course designed to help you develop strategic communication, negotiation, and client management skills. Whether you’re new to the field or looking to refine your expertise, this course will guide you in fostering long-term professional relationships that drive success in business and customer engagement.",
    btnText_1:"Enroll Now",
    btnText_2:"Schedule Free Demo",
    image:IMAGES.BANKING_HERO_2,
 }
 export const BANKING_COURSE_PAGE_2={
  image:IMAGES.BANKING_COURSE_2,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience in relationship-building and client management."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your expertise in relationship management to potential employers.",


      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",

    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const BANKING_DETAILS_PAGE_2 = {
  title: "Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, case studies, and live interaction sessions",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, CRM tool tutorials, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from industry experts with extensive experience in customer relationship management and business strategy.",
    },
  ]
};
// page3
export const BANKING_HERO_PAGE_3 = {
  title: "Enhance Your Career",
  heading: "Banking Sales & Relationship Management",
  content:
    "Step into the dynamic world of banking sales and relationship management with our industry-focused course. Whether you are aspiring to work in retail banking, wealth management, or corporate banking, this program equips you with the essential sales techniques, client relationship strategies, and financial product knowledge to excel in the competitive banking sector.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.BANKING_HERO_3,
};
export const BANKING_COURSE_PAGE_3 = {
  image: IMAGES.BANKING_COURSE_3,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const BANKING_DETAILS_PAGE_3 = {
  title: "Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, case studies, and live interaction sessions",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, CRM tool tutorials, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from industry experts with extensive experience in customer relationship management and business strategy.",
    },
  ]
};

// page-4
export const BANKING_HERO_PAGE_4 = {
  title: "Enhance Your Career",
  heading: "Kickstart Your Banking Career",
  content:
    "Prepare for a successful career in banking with our industry-focused course tailored for undergraduate students. Whether you aim to work in retail banking, wealth management, or financial services, this course equips you with essential banking knowledge, sales strategies, and customer relationship management skills. Gain practical experience that gives you a competitive edge in the banking industry.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.BANKING_HERO_4,
};
export const BANKING_COURSE_PAGE_4 = {
  image: IMAGES.BANKING_COURSE_4,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const BANKING_DETAILS_PAGE_4 = {
  title: "Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, case studies, and live interaction sessions",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, CRM tool tutorials, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from industry experts with extensive experience in customer relationship management and business strategy.",
    },
  ]
};
// =================================================
// software Engineer
// page-1
export const SOFTWARE_HERO_PAGE_1 = {
  title: "Enhance Your Career",
  heading: "Master Full Stack Development: From Frontend to Backend",
  content:
    "Become a versatile full stack developer with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're starting from scratch or looking to enhance your skills, this course will guide you through every aspect of building modern web applications. Learn to create seamless user experiences, manage databases, and deploy scalable applications—all in one program.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_1,
};
export const SOFTWARE_COURSE_PAGE_1 = {
  image: IMAGES.SOFTWARE_COURSES_1,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_1 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-2
export const SOFTWARE_HERO_PAGE_2 = {
  title: "Enhance your career",
  heading: "Master JavaScript: From Basics to Advanced",
  content:
    "Become a proficient JavaScript developer with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're starting from scratch or looking to enhance your skills, this course will guide you through every aspect of JavaScript—one of the most in-demand programming languages today.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_2,
};
export const SOFTWARE_COURSE_PAGE_2 = {
  image: IMAGES.SOFTWARE_COURSES_2,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_2 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// pag-3
export const SOFTWARE_HERO_PAGE_3 = {
  title: "Enhance your career",
  heading: "Master Frontend Development with React.js",
  content:
    "Become a skilled frontend developer with our hands-on, comprehensive course designed to take you from beginner to expert in React.js. Whether you're starting from scratch or looking to enhance your skills, this course will guide you through every aspect of building modern, interactive, and responsive user interfaces. Learn to create seamless web experiences and build real-world projects that will set you apart in the tech industry.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_3,
};
export const SOFTWARE_COURSE_PAGE_3 = {
  image: IMAGES.SOFTWARE_COURSES_3,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_3 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-4
export const SOFTWARE_HERO_PAGE_4 = {
  title: "Enhance your career",
  heading: "Master Mobile Development: Build Apps for Android & iOS",
  content:
    "Become a proficient mobile app developer with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're new to mobile development or looking to enhance your skills, this course will guide you through building high-performance, user-friendly applications for both Android and iOS using the latest technologies.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_4,
};
export const SOFTWARE_COURSE_PAGE_4 = {
  image: IMAGES.SOFTWARE_COURSES_4,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_4 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-5
export const SOFTWARE_HERO_PAGE_5 = {
  title: "Enhance your career",
  heading: "Master Software Testing: Ensure Quality & Reliability",
  content:
    "Become a proficient software tester with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're new to testing or looking to enhance your skills, this course will equip you with the knowledge and tools to identify bugs, improve software quality, and ensure seamless user experiences across applications.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_5,
};
export const SOFTWARE_COURSE_PAGE_5 = {
  image: IMAGES.SOFTWARE_COURSES_5,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_5 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-6

export const SOFTWARE_HERO_PAGE_6 = {
  title: "Enhance your career",
  heading: "Master Java Development: Build Scalable Applications",
  content:
    "Become a skilled Java developer with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're new to programming or looking to refine your Java skills, this course will guide you through building robust, high-performance applications used in web, mobile, and enterprise environments.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_6,
};
export const SOFTWARE_COURSE_PAGE_6 = {
  image: IMAGES.SOFTWARE_COURSES_6,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_6 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-7
export const SOFTWARE_HERO_PAGE_7 = {
  title: "Enhance your career",
  heading:
    "Master Automation Testing : BuildReliable & Scalable Test Frameworks",
  content:
    "Become a skilled automation tester with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you're new to testing or looking to advance your career, this course will equip you with the latest tools and techniques to automate software testing, improve efficiency, and ensure bug-free applications.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_7,
};
export const SOFTWARE_COURSE_PAGE_7 = {
  image: IMAGES.SOFTWARE_COURSES_7,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_7 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-8
export const SOFTWARE_HERO_PAGE_8 = {
  title: "Enhance your career",
  heading: "Master Power BI: Transform Data into Actionable Insights",
  content:
    "Become a skilled data analyst with our hands-on, comprehensive Power BI course designed to take you from beginner to expert. Whether you are new to data visualization or looking to advance your analytics skills, this course will help you turn raw data into compelling, interactive dashboards and reports for informed decision-making.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_8,
};
export const SOFTWARE_COURSE_PAGE_8 = {
  image: IMAGES.SOFTWARE_COURSES_8,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_8 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page-9
export const SOFTWARE_HERO_PAGE_9 = {
  title: "Enhance your career",
  heading: "Master Game Development: Build Engaging & Interactive Games",
  content:
    "Become a skilled game developer with our hands-on, comprehensive course designed to take you from beginner to expert. Whether you are new to game development or looking to refine your skills, this course will guide you through building immersive games using industry-standard tools like Unity and Unreal Engine.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.SOFTWARE_HERO_9,
};
export const SOFTWARE_COURSE_PAGE_9 = {
  image: IMAGES.SOFTWARE_COURSES_9,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const SOFTWARE_DETAILS_PAGE_9 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
export const FOOTER_DESC = {
  title: "Empowering futures through technology education.",
  content:
    "Grow your career by learning the latest IT skills that are essential for success in today’s tech-driven world.",
  btnText: "Join Now",
};
// ================================================
// Data Science
export const DATA_HERO_PAGE_1 = {
  title: "Enhance your career",
  heading: "Master DS & ML: From Fundamentals to Advanced Applications",
  content:
    "Unlock the power of data science and machine learning (ML) with our comprehensive course. Whether you're a beginner or looking to refine your skills, this program covers everything from data analysis and visualization to predictive modeling and AI-driven solutions. Gain hands-on experience with Python, SQL, TensorFlow, and real-world datasets to become a job-ready data scientist or ML engineer.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DATA_HERO_1,
};
export const DATA_COURSE_PAGE_1 = {
  image: IMAGES.DATA_COURSES_1,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const DATA_DETAILS_PAGE_1 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page2
export const DATA_HERO_PAGE_2 = {
  title: "Enhance your career",
  heading: "Master AI & ML Learning: Build the Future with AI",
  content:
    "Step into the world of Artificial Intelligence (AI) and Machine Learning (ML) with our industry-leading course. This program is designed to help you master AI-powered solutions, deep learning, neural networks, and automation using cutting-edge tools like Python, TensorFlow, Keras, and NLP frameworks. Whether you're a beginner or looking to advance your skills, this course will guide you to become an AI/ML expert.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DATA_HERO_2,
};
export const DATA_COURSE_PAGE_2 = {
  image: IMAGES.DATA_COURSES_2,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const DATA_DETAILS_PAGE_2 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page3
export const DATA_HERO_PAGE_3 = {
  title: "Enhance your career",
  heading: "Master Data Analytics with Python & SQL",
  content:
    "Unlock the potential of data analytics with Python and SQL, two of the most powerful tools in the industry. This course equips you with the skills to extract, clean, analyze, and visualize data efficiently. Whether you’re aiming for a career in business intelligence, data science, or analytics, this hands-on program will help you gain proficiency in data-driven decision-making using real-world datasets and industry-standard tools.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DATA_HERO_3,
};
export const DATA_COURSE_PAGE_3 = {
  image: IMAGES.DATA_COURSES_3,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const DATA_DETAILS_PAGE_3 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// page4
export const DATA_HERO_PAGE_4 = {
  title: "Enhance your career",
  heading: "Become an Artificial Intelligence Engineer",
  content:
    "Step into the future of technology with our Artificial Intelligence Engineer course. This program covers everything from machine learning, deep learning, and natural language processing (NLP) to AI-driven automation and computer vision. Gain hands-on experience with cutting-edge tools like Python, TensorFlow, Keras, and OpenAI frameworks to build real-world AI applications. Whether you’re starting fresh or upskilling, this course will make you job-ready for AI engineering roles.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DATA_HERO_4,
};
export const DATA_COURSE_PAGE_4 = {
  image: IMAGES.DATA_COURSES_4,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};
export const DATA_DETAILS_PAGE_4 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};
// ========================================================
// Digital marketing
// page1
export const DIGITAL_HERO_PAGE_1 = {
  title: "Enhance Your Career",
  heading: "Master Digital Marketing with Generative AI",
  content:
    "Stay ahead in the rapidly evolving digital landscape by mastering Digital Marketing with Generative AI. This course blends traditional marketing strategies with cutting-edge AI tools to help you automate content creation, optimize ad campaigns, personalize customer experiences, and analyze data-driven insights. Learn how to leverage ChatGPT, Midjourney, Google AI, and automation tools to create innovative and high-impact digital marketing campaigns.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DIGITAL_HERO_1,
};

export const DIGITAL_COURSE_PAGE_1 = {
  image: IMAGES.DIGITAL_COURSES_1,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const DIGITAL_DETAILS_PAGE_1 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {

      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, AI-driven content creation, and campaign optimization",


      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",

    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};

// page2

export const DIGITAL_HERO_PAGE_2 = {
  title: "Enhance Your Career",
  heading: "Master SEO & Growth Marketing",
  content:
    "Unlock the secrets to SEO & Growth Marketing with our hands-on, expert-led course. Learn how to optimize websites for search engines, craft high-converting marketing strategies, leverage AI for automation, and scale businesses using data-driven techniques. Whether you’re a beginner or an experienced marketer, this course will equip you with the skills needed to increase online visibility, boost engagement, and drive sustainable growth.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DIGITAL_HERO_2,
};

export const DIGITAL_COURSE_PAGE_2 = {
  image: IMAGES.DIGITAL_COURSES_2,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const DIGITAL_DETAILS_PAGE_2 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {

      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, AI-driven content creation, and campaign optimization",


      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",

    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};

// page3
export const DIGITAL_HERO_PAGE_3 = {
  title: "Enhance Your Career",
  heading: "Master Social Media & Influencer Marketing",
  content:
    "Stay ahead in the fast-paced world of social media and influencer marketing with our expert-led course. Learn how to create viral campaigns, grow social media communities, collaborate with influencers, and use AI-driven tools for content strategy and engagement tracking. Whether you're a marketer, entrepreneur, or content creator, this course will equip you with the skills to build brand presence, increase audience reach, and drive sales through social platforms.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DIGITAL_HERO_3,
};

export const DIGITAL_COURSE_PAGE_3 = {
  image: IMAGES.DIGITAL_COURSES_3,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const DIGITAL_DETAILS_PAGE_3 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {

      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, AI-driven content creation, and campaign optimization",


      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",

    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};

// page4

export const DIGITAL_HERO_PAGE_4 = {
  title: "Enhance Your Career",
  heading: "Master Email Marketing",
  content:
    "Unlock the power of Email Marketing and learn how to craft compelling emails, automate campaigns, segment audiences, and optimize for conversions. This course equips you with AI-driven tools, automation techniques, and data-driven strategies to help businesses boost engagement, generate leads, and increase sales through email marketing.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DIGITAL_HERO_4,
};

export const DIGITAL_COURSE_PAGE_4 = {
  image: IMAGES.DIGITAL_COURSES_4,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const DIGITAL_DETAILS_PAGE_4 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {

      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, AI-driven content creation, and campaign optimization",


      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",

    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};

// page5

export const DIGITAL_HERO_PAGE_5 = {
  title: "Enhance Your Career",
  heading: `Master Content Marketing: Create Engaging Content`,
  content:
    "Become a content marketing expert with our comprehensive course. Learn how to craft compelling content, develop brand storytelling, optimize for SEO, leverage AI tools, and distribute content effectively across digital platforms. Whether you’re a marketer, entrepreneur, or content creator, this course will equip you with the skills to build brand authority, drive engagement, and convert audiences into loyal customers.",
  btnText_1: "Enroll Now",
  btnText_2: "Schedule Free Demo",
  image: IMAGES.DIGITAL_HERO_5,
};

export const DIGITAL_COURSE_PAGE_5 = {
  image: IMAGES.DIGITAL_COURSES_5,
  title: "Why Choose Our Course?",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Learn by Doing",
      content:
        "Our project-based curriculum ensures you gain real-world experience in relationship-building and client management.",
    },
    {
      icon: IMAGES.BANKING_ICON_2,
      heading: "Industry-Recognized Certificate",
      content:
        "Receive a certificate that demonstrates your expertise in relationship management to potential employers.",
    },
    {
      icon: IMAGES.BANKING_ICON_3,
      heading: "Flexible Learning",
      content:
        "Study at your own pace with lifetime access to course materials.",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Student Support",
      content:
        "Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ],
};

export const DIGITAL_DETAILS_PAGE_5 = {
  title: "Course Details",
  content:"",
  Cards: [
    {
      icon: IMAGES.BANKING_ICON_5,
      heading: "Duration",
      content: "8-12 weeks (self-paced or instructor-led options available)",
    },
    {
      icon: IMAGES.BANKING_ICON_4,
      heading: "Mode of Delivery",
      content: "Online, in-person, and hybrid options",
    },
    {
      icon: IMAGES.BANKING_ICON_1,
      heading: "Hands-on Learning",
      content: "80% practical assignments, projects, and live coding sessions",
    },
    {
      icon: IMAGES.BANKING_ICON_6,
      heading: "Access to Resources",
      content:
        "Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon: IMAGES.BANKING_ICON_7,
      heading: "Expert Instructors",
      content:
        "Learn from industry experts with extensive software development experience.",
    },
  ],
};



export const START_NEW_CAREER_DATA = [
  {
    id: "Popular",
    cards: [
      {
        id: 1,
        heading: "Full-Stack Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_1,
      },
      {
        id: 2,
        heading: "Frontend Development with React Js",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_3,
      },
      {
        id: 3,
        heading: "Mobile Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_4,
      },
      {
        id: 4,
        heading: "Cyber Security for Beginners ",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.CYBER_COURSES_1,
      },
    ],
  },
  {
    id: "Banking and Finance",
    cards: [
      {
        id: 1,
        heading: "Program In Relationship Management",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.BANKING_COURSE_1,
      },
      {
        id: 2,
        heading: "Relationship Management for Under Graduates",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.BANKING_COURSE_2,
      },
      {
        id: 3,
        heading: "Program in Banking Sales & Relationship Management",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.BANKING_COURSE_3,
      },
      {
        id: 4,
        heading: "Banking Sales and Relationship Management for Under Graduates",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.BANKING_COURSE_4,
      },
    ],
  },
  {
    id: "Software Engineering",
    cards: [
      {
        id: 1,
        heading: "Full-Stack Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_1,
      },
      {
        id: 2,
        heading: "Master JavaScript",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_2,
      },
      {
        id: 3,
        heading: "Frontend Development with React Js",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_3,
      },
      {
        id: 4,
        heading: "Mobile Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_4,
      },
      {
        id: 5,
        heading: "Software Testing",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_5,
      },
      {
        id: 6,
        heading: "Java Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_6,
      },
      {
        id: 7,
        heading: "Automation Testing",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_7,
      },
      {
        id: 8,
        heading: "Power BI",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_8,
      },
      {
        id: 9,
        heading: "Game Development",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.SOFTWARE_COURSES_9,
      },
    ],
  },
  {
    id: "Data Science",
    cards: [
      {
        id: 1,
        heading: "Data Science and ML",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DATA_COURSES_1,
      },
      {
        id: 2,
        heading: "Artificial Intelligence and Machine Learning",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DATA_COURSES_2,
      },
      {
        id: 3,
        heading: "Data Analytics using Python and SQL",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DATA_COURSES_3,
      },
      {
        id: 4,
        heading: "Artificial Intelligence Engineer",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DATA_COURSES_4,
      },
    ],
  },
  {
    id: "Digital Marketing",
    cards: [
      {
        id: 1,
        heading: "Digital Marketing with GenAI",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DIGITAL_COURSES_1,
      },
      {
        id: 2,
        heading: "SEO and Growth Marketing ",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DIGITAL_COURSES_2,
      },
      {
        id: 3,
        heading: "Social Media and Influencer Marketing",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DIGITAL_COURSES_3,
      },
      {
        id: 4,
        heading: "Email Marketing",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DIGITAL_COURSES_4,
      },
      {
        id: 5,
        heading: "Content Marketing",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DIGITAL_COURSES_5,
      },
    ],
  },
  {
    id: "Cyber Security",
    cards: [
      {
        id: 1,
        heading: "Cyber Security for Beginners ",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.CYBER_COURSES_1,
      },
      {
        id: 2,
        heading: "Advanced Cyber Security",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.CYBER_COURSES_2,
      },

    ],
  },
  {
    id: "Design",
    cards: [
      {
        id: 1,
        heading: "UI & UX Design",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DESIGN_COURSES_1,
      },
      {
        id: 2,
        heading: "Graphic Design",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DESIGN_COURSES_2,
      },
      {
        id: 3,
        heading: "Product Design",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.DESIGN_COURSES_3,
      },
    ],
  },
  {
    id: "Cloud Computing",
    cards: [
      {
        id: 1,
        heading: "IT SysAdmin & Cloud Computing Program ",
        content: [
          "Available in both online and offline.",
          "Duration: 6 Months.",
          "Lectured by 7+ years experienced trainer.",
          "more",
        ],
        btnText: "Learn More",
        btnIcon: IMAGES.CHEVRON_RIGHT,
        link: "/software_page-6",
        image: IMAGES.CLOUD_COURSES,
      },
    ],
  },
];

export const REVIEWS_DATA = [
  [
    {
      id: 1,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",
    },
    {
      id: 2,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",
    },
    {

      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, AI-driven content creation, and campaign optimization",


      id: 3,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",

    },
  ],
  [
    {
      id: 4,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",
    },
    {
      id: 5,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",
    },
    {
      id: 6,
      content:
        '"The courses are incredibly well-structured and engaging! I never thought I could learn Data Science so quickly. The hands-on projects made all the difference."',
      tag: "— Emily R.",
    },
  ],
];


// export const OVERALL_COURSES=[
//   "Program In Relationship Management",
//   "Relationship Management for Under Graduates",
//   "Program in Banking Sales & Relationship Management",
//   "Banking Sales and Relationship Management for Under Graduates",
//   "Full-Stack Development",

// ]


// Cyber security
// page1

export const CYBER_HERO_PAGE_1={
  title:"Enhance Your Career",
   heading:`Protect Digital Assets & Defend Against Cyber Threats`,
   content:"Kickstart your journey into cybersecurity with our beginner-friendly course. Learn how to identify cyber threats, secure digital systems, prevent hacking attempts, and safeguard sensitive data. Whether you're a student, IT enthusiast, or aspiring cybersecurity professional, this course provides the fundamentals of ethical hacking, network security, encryption, and cyber laws to help you build a strong foundation in digital security.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CYBER_HERO_1,
 }

 export const CYBER_COURSE_PAGE_1={
  image:IMAGES.CYBER_COURSES_1,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}


export const CYBER_DETAILS_PAGE_1={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, cybersecurity labs, and live penetration testing",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from ethical hackers, cybersecurity analysts, and IT security professionals.",
    },
  ]

}

// Page2

export const CYBER_HERO_PAGE_2={
  title:"Enhance Your Career",
   heading:`Master Advanced Cyber Security`,
   content:"Take your cybersecurity expertise to the next level with our Advanced Cyber Security Course. Learn how to mitigate cyber threats, conduct penetration testing, secure enterprise networks, and implement advanced encryption protocols. Whether you're an IT professional, ethical hacker, or security analyst, this course will equip you with the skills to protect digital assets, detect vulnerabilities, and respond to cyber incidents in real-world environments.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CYBER_HERO_2,
 }

 export const CYBER_COURSE_PAGE_2={
  image:IMAGES.CYBER_COURSES_2,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}


export const CYBER_DETAILS_PAGE_2={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, cybersecurity labs, and live penetration testing",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from ethical hackers, cybersecurity analysts, and IT security professionals.",
    },
  ]

}

// clouding

export const CLOUD_HERO_PAGE_1={
  title:"Enhance Your Career",
   heading:`Master IT System Administration & Cloud Computing`,
   content:"Take your IT career to the next level with our IT SysAdmin & Cloud Computing Program. Learn how to deploy, manage, and secure IT systems and cloud environments used by enterprises worldwide. Gain expertise in Linux & Windows administration, networking, virtualization, cloud services (AWS, Azure, GCP), and IT security to become a highly sought-after System Administrator or Cloud Engineer.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CLOUD_HERO,
 }

 export const CLOUD_COURSE_PAGE_1={
  image:IMAGES.CLOUD_COURSES,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CLOUD_DETAILS_PAGE_1={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical assignments, live cloud projects, and IT infrastructure simulations",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from certified AWS, Azure, and Google Cloud professionals.",
    },
  ]

}


// certification
// page1
export const CERTIFICATION_HERO_PAGE_1={
  title:"Enhance Your Career",
   heading:`Master Python: From Fundamentals to Advanced Applications`,
   content:"Kickstart your journey with our Python Certification Program and gain expertise in one of the world's most versatile and in-demand programming languages. Whether you’re a beginner or looking to advance your coding skills, this course covers everything from basic syntax to advanced data structures, automation, web development, and data science.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CERTIFICATION_HERO_1,
 }

 export const CERTIFICATION_COURSE_PAGE_1={
  image:IMAGES.CERTIFICATION_COURSES_1,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CERTIFICATION_DETAILS_PAGE_1={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical coding exercises, assignments, and capstone projects",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from experienced Python developers, data scientists, and software engineers.",
    },
  ]

}

// page2
export const CERTIFICATION_HERO_PAGE_2={
  title:"Enhance Your Career",
   heading:`Master Java: From Fundamentals to Advanced Applications`,
   content:"Take your programming skills to the next level with our Java Certification Program. Whether you're a beginner or an experienced developer, this course will help you master Java programming, object-oriented concepts, data structures, web development, and enterprise applications. Gain hands-on experience with real-world projects and become job-ready for roles in software development, backend engineering, and enterprise solutions.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CERTIFICATION_HERO_2,
 }

 export const CERTIFICATION_COURSE_PAGE_2={
  image:IMAGES.CERTIFICATION_COURSES_2,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CERTIFICATION_DETAILS_PAGE_2={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical coding exercises, assignments, and capstone projects",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from experienced Python developers, data scientists, and software engineers.",
    },
  ]

}

// page3
export const CERTIFICATION_HERO_PAGE_3={
  title:"Enhance Your Career",
   heading:`Master Cloud Computing with the AWS Certification Program`,
   content:"Become an AWS-certified cloud professional and advance your career in cloud computing, DevOps, and infrastructure management. This comprehensive course covers AWS services, cloud architecture, security, automation, and deployment strategies. Whether you're preparing for AWS Certified Cloud Practitioner, Solutions Architect, Developer, or SysOps Administrator, this program equips you with hands-on expertise to succeed.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CERTIFICATION_HERO_3,
 }

 export const CERTIFICATION_COURSE_PAGE_3={
  image:IMAGES.CERTIFICATION_COURSES_3,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CERTIFICATION_DETAILS_PAGE_3={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical coding exercises, assignments, and capstone projects",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from experienced Python developers, data scientists, and software engineers.",
    },
  ]

}

// page4
export const CERTIFICATION_HERO_PAGE_4={
  title:"Enhance Your Career",
   heading:`Master Cloud Computing with the Microsoft Azure Certification Program`,
   content:"Advance your career in cloud computing and enterprise solutions with our Microsoft Azure Certification Program. This course prepares you for Azure Fundamentals (AZ-900), Azure Administrator (AZ-104), Azure Solutions Architect (AZ-305), and Azure DevOps Engineer (AZ-400). Gain hands-on experience in cloud architecture, networking, security, automation, and deployment strategies to become an Azure-certified professional.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CERTIFICATION_HERO_4,
 }

 export const CERTIFICATION_COURSE_PAGE_4={
  image:IMAGES.CERTIFICATION_COURSES_4,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CERTIFICATION_DETAILS_PAGE_4={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical coding exercises, assignments, and capstone projects",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from experienced Python developers, data scientists, and software engineers.",
    },
  ]

}

// page5
export const CERTIFICATION_HERO_PAGE_5={
  title:"Enhance Your Career",
   heading:`Master CRM with the Salesforce Certification Program`,
   content:"Unlock new career opportunities in customer relationship management (CRM), cloud computing, and enterprise solutions with our Salesforce Certification Program. This course prepares you for Salesforce Administrator (ADM-201), Salesforce Developer (PD-1), and Salesforce Consultant certifications. Gain hands-on experience in Salesforce automation, data modeling, security, app development, and cloud integration to become a Salesforce-certified professional.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.CERTIFICATION_HERO_5,
 }

 export const CERTIFICATION_COURSE_PAGE_5={
  image:IMAGES.CERTIFICATION_COURSES_5,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const CERTIFICATION_DETAILS_PAGE_5={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical coding exercises, assignments, and capstone projects",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Study material, coding challenges, and 24/7 access to course forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from experienced Python developers, data scientists, and software engineers.",
    },
  ]

}

// design
// page1
export const DESIGN_HERO_PAGE_1={
  title:"Enhance Your Career",
   heading:`Master UI & UX Design for Engaging Digital Experiences`,
   content:"Learn how to create intuitive, user-friendly, and visually stunning digital products with our UI & UX Design Program. This course will equip you with design thinking, wireframing, prototyping, user research, and usability testing skills. Whether you're an aspiring designer, product manager, or developer, this program will help you craft seamless user experiences for websites, apps, and software platforms.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.DESIGN_HERO_1,
 }

 export const DESIGN_COURSE_PAGE_1={
  image:IMAGES.DESIGN_COURSES_1,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const DESIGN_DETAILS_PAGE_1={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical exercises, real-world projects, and live design challenges",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Design templates, UI kits, usability testing guides, and 24/7 support forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from senior UI/UX designers with experience in leading tech companies.",
    },
  ]

}

// page2
export const DESIGN_HERO_PAGE_2={
  title:"Enhance Your Career",
   heading:`Master Graphic Design: Create Stunning Visuals`,
   content:"Turn your creativity into a career with our Graphic Design Program. This course covers branding, digital illustration, typography, motion graphics, and UI design using industry-leading tools like Adobe Photoshop, Illustrator, InDesign, and Canva. Whether you want to become a freelance designer, brand strategist, or digital artist, this program will equip you with the skills to craft compelling visual content for web, print, and social media.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.DESIGN_HERO_2,
 }

 export const DESIGN_COURSE_PAGE_2={
  image:IMAGES.DESIGN_COURSES_2,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const DESIGN_DETAILS_PAGE_2={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical exercises, real-world projects, and live design challenges",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Design templates, UI kits, usability testing guides, and 24/7 support forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from senior UI/UX designers with experience in leading tech companies.",
    },
  ]

}

// page3
export const DESIGN_HERO_PAGE_3={
  title:"Enhance Your Career",
   heading:`Master Product Design: From Concept to Creation`,
   content:"Learn to design, prototype, and launch innovative products with our Product Design Program. This course covers design thinking, user research, prototyping, and usability testing using industry-standard tools like Figma, Adobe XD, AutoCAD, and SolidWorks. Whether you're an aspiring UX designer, industrial designer, or product manager, this program equips you with the skills to create functional and visually appealing digital and physical products.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.DESIGN_HERO_3,
 }

 export const DESIGN_COURSE_PAGE_3={
  image:IMAGES.DESIGN_COURSES_3,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const DESIGN_DETAILS_PAGE_3={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical exercises, real-world projects, and live design challenges",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Design templates, UI kits, usability testing guides, and 24/7 support forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from senior UI/UX designers with experience in leading tech companies.",
    },
  ]

}

// agile and scum
// page1
export const AGILE_HERO_PAGE_1={
  title:"Enhance Your Career",
   heading:`Become a Certified Scrum Master (CSM) and Lead Agile Teams`,
   content:"Gain expertise in Agile methodologies, Scrum framework, and team collaboration with our Certified Scrum Master (CSM) Training Program. This course prepares you to facilitate Agile projects, enhance team productivity, and drive successful product development. Whether you're an aspiring Scrum Master, project manager, or software developer, this certification will open doors to exciting career opportunities in Agile-driven organizations.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.AGILE_HERO_1,
 }

 export const AGILE_COURSE_PAGE_1={
  image:IMAGES.AGILE_COURSES_1,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const AGILE_DETAILS_PAGE_1={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical Agile exercises, Scrum simulations, and interactive workshops",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Scrum guides, Agile playbooks, Sprint planning templates, and 24/7 access to discussion forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from Certified Scrum Trainers (CSTs) with real-world Agile coaching experience.",
    },
  ]

}

// page2
export const AGILE_HERO_PAGE_2={
  title:"Enhance Your Career",
   heading:`Master Product Ownership with the PSPO Certification`,
   content:"Develop the skills to define product vision, manage backlogs, and maximize business value with our Professional Scrum Product Owner (PSPO) Certification Program. This course equips you with the expertise to collaborate with stakeholders, prioritize features, and drive Agile product success. Whether you're an aspiring Product Owner, business analyst, or product manager, this certification will elevate your career in Agile-driven organizations.",
   btnText_1:"Enroll Now",
   btnText_2:"Schedule Free Demo",
   image:IMAGES.AGILE_HERO_2,
 }

 export const AGILE_COURSE_PAGE_2={
  image:IMAGES.AGILE_COURSES_2,
  title:"Why Choose Our Course?",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Learn by Doing",
      content:"Our project-based curriculum ensures you gain real-world experience."
    },
    {
      icon:IMAGES.BANKING_ICON_2,
      heading:"Industry-Recognized Certificate",
      content:"Receive a certificate that demonstrates your proficiency to potential employers.",

    },
    {
      icon:IMAGES.BANKING_ICON_3,
      heading:"Flexible Learning",
      content:"Study at your own pace with lifetime access to course materials.",

    },
     {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Student Support",
      content:"Get help anytime through Q&A forums, instructor office hours, and peer collaborations.",
    },
  ]

}

export const AGILE_DETAILS_PAGE_2={
  
  title:"Course Details",
  content:"",
  Cards:[
    {
      icon:IMAGES.BANKING_ICON_5,
      heading:"Duration",
      content:"8-12 weeks (self-paced or instructor-led options available)"
    },
    {
      icon:IMAGES.BANKING_ICON_4,
      heading:"Mode of Delivery",
      content:"Online, in-person, and hybrid options",

    },
    {
      icon:IMAGES.BANKING_ICON_1,
      heading:"Hands-on Learning",
      content:"80% practical Agile exercises, Scrum simulations, and interactive workshops",

    },
     {
      icon:IMAGES.BANKING_ICON_6,
      heading:"Access to Resources",
      content:"Scrum guides, Agile playbooks, Sprint planning templates, and 24/7 access to discussion forums",
    },
    {
      icon:IMAGES.BANKING_ICON_7,
      heading:"Expert Instructors",
      content:"Learn from Certified Scrum Trainers (CSTs) with real-world Agile coaching experience.",
    },
  ]

}


export const ENROLL_BOTTOM_CONTENT={
  title:"Our Location",
  content:`GET PLACED INDIA PRIVATE LIMITED 
  Rajapushpa Summit, SY. 130P & 115/1P, Nanakramguda Rd, Ranga Reddy Dist., Financial 
  District, Manikonda Jagir, Telangana 500032`,
  btnText:"Get Directions"
}


export const OVERALL_COURSES= NavItem_Course[0].data.reduce((acc,curr)=>{
  curr.courses.map((item)=> {acc.push({title:item.heading,link:item.link})})
  return acc
},[])
